import MarketingLayout from "@/components/MarketingLayout";
import { blogPosts } from "@/lib/blogPosts";
import { CalendarDays } from "lucide-react";
import { Link } from "wouter";

function formatPublishedDate(date: string) {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(date));
}

export default function Blog() {
  return (
    <MarketingLayout>
      <section className="container py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Double O Blog
          </h1>
          <p className="text-lg text-muted-foreground mb-10">
            Practical guides on secrets management, secure development workflows,
            and production-ready patterns for data teams.
          </p>

          <div className="space-y-6">
            {blogPosts.map(post => (
              <Link key={post.slug} href={`/blog/${post.slug}`}>
                <article className="rounded-lg border border-border bg-card p-6 transition-colors hover:bg-muted/40 cursor-pointer">
                  <div className="flex items-center gap-4 text-sm text-muted-foreground mb-3">
                    <span className="inline-flex items-center gap-1">
                      <CalendarDays className="w-4 h-4" />
                      <time dateTime={post.publishedAt}>
                        {formatPublishedDate(post.publishedAt)}
                      </time>
                    </span>
                    <span>{post.readingTime}</span>
                  </div>
                  <h2 className="text-xl font-semibold text-card-foreground mb-2">
                    {post.title}
                  </h2>
                  <p className="text-muted-foreground">{post.description}</p>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
